module.exports = __webpack_public_path__ + "img/diverse-workforces-mobile.85cdf00f.webp";